import React from "react";
import Link from "gatsby-link";
import Burger from "./burger";
import Search from "../Search";

const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

const NavbarItem = ({path, to, name, handleSelect}) => {
  const classes = path === to ? "is-active navbar-item" : "navbar-item";
  return (
    <Link to={to} className={classes} onClick={handleSelect}>
      {name}
    </Link>
  );
};

const NavbarLink = ({path, to, name, handleSelect}) => {
  const classes = path === to ? "is-active navbar-link" : "navbar-link";
  return (
    <Link to={to} className={classes} onClick={handleSelect}>
      <span>
        {name}
      </span>
    </Link>
  );
};

export default class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hamburgerIsActive: false,
      scrollPositionY: 0,
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    return window.addEventListener("scroll", debounce(this.handleScroll, 16));
  }

  handleClick() {
    this.setState(prevState => ({
      hamburgerIsActive: !prevState.hamburgerIsActive
    }));
  }

  handleSelect() {
    this.setState({hamburgerIsActive: false});
  }

  handleScroll() {
    const scrollPositionY = window.scrollY;
    return this.setState({scrollPositionY});
  }

  render() {
    let navBarClasses = "navbar-menu";
    const {hamburgerIsActive, scrollPositionY, path} = this.state;

    if (hamburgerIsActive) {
      navBarClasses += " is-active";
    }

    const isScrolled = !!scrollPositionY;

    return (
      <nav className={`navbar is-fixed-top ${isScrolled ? "is-link" : "is-transparent transparent-nav"}`}>
        <div className="container">
          <div className="navbar-brand">
            <Link to="/" className="navbar-item">
              <img src="/logos/oncezone-large.png" alt="Once Zone Logo" />
            </Link>
            <Burger
              handleClick={this.handleClick}
              hamburgerIsActive={hamburgerIsActive}
            />
          </div>

          <div id="navBar" className={navBarClasses}>
            <div className="navbar-start">
              <NavbarItem handleSelect={this.handleSelect} path={path} to="/" name="Home" />
              <div className="navbar-item has-dropdown is-hoverable">
                <NavbarLink handleSelect={this.handleSelect} path={path} to="/videos" name="Videos" />

                <div className={`navbar-dropdown ${isScrolled ? "" : "is-boxed"}`}>
                  <NavbarItem handleSelect={this.handleSelect} path={path} to="/videos-by-era" name="By Era" />
                  <NavbarItem handleSelect={this.handleSelect} path={path} to="/videos-by-type" name="By Type" />
                  <hr className="navbar-divider" />
                  <NavbarItem handleSelect={this.handleSelect} path={path} to="/videos" name="All Videos" />
                </div>
              </div>
              <NavbarItem handleSelect={this.handleSelect} path={path} to="/posts" name="Blog" />
              <NavbarItem handleSelect={this.handleSelect} path={path} to="/progress" name="Progress" />
              <NavbarItem hanldeSelect={this.handleSelect} path={path} to="/schedule" name="Schedule" />
              <NavbarItem handleSelect={this.handleSelect} path={path} to="/team" name="Team" />
              <NavbarItem handleSelect={this.handleSelect} path={path} to="/donate" name="Donate" />
              <NavbarItem handleSelect={this.handleSelect} path={path} to="/contact" name="Contact" />

            </div>
            <div className="navbar-end">
              <Search isScrolled={isScrolled} />
            </div>
          </div>
        </div>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NavBar/index.jsx